
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import shoplist from '@/components/shoplist.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      shoplist,
    }
  })

  export default class ProductList extends Vue {
    private show = false
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    private showlist(){
      this.show = true
    }
    private delshop(i){
      this.editinfo.msg.list.splice(i,1)
    }
    private getshop(e){
      if(!e||!e.length){
        this.$message.error('请选择商品')
        return 
      }
      if(e.length > 200){
        this.$message.error('最多添加200件商品')
        return 
      }
      let OpenTime = new Date(e[0].OpenTime.substring(0,10)).getTime()
      let TakedownTime = new Date(e[0].TakedownTime.substring(0,10)).getTime()
      for(let item of e){
        if(new Date(item.OpenTime.substring(0,10)).getTime()!=OpenTime||new Date(item.TakedownTime.substring(0,10)).getTime()!=TakedownTime){
          this.$message.error('添加失败，秒杀商品开团日期必须一致')
          return 
        }
      }
      this.show = false
      this.editinfo.msg.list = e.map(v=>{
        let pri = v.GroupPrice.toFixed(2).split('.')
        v.pointLeft = pri[0]
        v.pointRight = pri[1]
        if(v.pointRight.substring(1,1)=='0'||v.pointRight.substring(1,1)==''){
          v.pointRight = v.pointRight.substring(0,1)
        }
        return v
      })
    }
  }
